import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { OauthAEMConfig } from '../../../models';
import { InitiateUserRegistration } from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class InitiateUserRegistrationService {
  initiateUserRegistrationHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.initiateRegistration+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  initiateUserRegistration = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<InitiateUserRegistration> => {
    const getInitiateUserRegistrationUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const initiateUserRegistrationUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getInitiateUserRegistrationUrl
      }
    ];

    return new ApiBuilder<undefined, InitiateUserRegistration>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(initiateUserRegistrationUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.initiateUserRegistrationHeader)
      .errorHandler(this._errorHandler)
      .library('INITIATE_USER_REGISTRATION')
      .withCredentials(true)
      .create();
  };
}
